module.exports = __webpack_public_path__ + "static/img/App item-4.e02ec99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item-4.png
// module id = S+o4
// module chunks = 12